import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
import React, { useMemo } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { gradients } from './constants';
import { getGradientIndexByString } from './utils';
var styles = xcss({
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  overflow: 'hidden'
});
var gradientStyles = gradients.map(function (gradient) {
  return xcss({
    backgroundImage: "linear-gradient(".concat(gradient, ")")
  });
});
export function FallbackGradient(props) {
  var gradientIndex = useMemo(function () {
    return getGradientIndexByString(props.stringToHash);
  }, [props.stringToHash]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: [styles, gradientStyles[gradientIndex]].concat(_toConsumableArray(Array.isArray(props.customStyles) ? props.customStyles : [props.customStyles]))
  }, props.children);
}